import React from "react";
import BaseLayout from "../../components/BaseLayout/BaseLayout";
import { StyledFAB } from "../../components/CustomStyles/CustomFAB";
import BootstrapInputSearch from "../../components/InputSearch/BootstrapInputSearch";
import IzyPagination from "../../components/IzyPagination";
import IzyTabsPanel from "../../components/IzyTabsPanel";
import { handleError } from "../../components/Utils/Utils";
import { GetTotalPage } from "../../Helpers/pagination";
import ProductService from "../../Services/ProductService/ProductService";
import ProductStore from "../../Store/ProductStore";
import { productForm } from "./Container/NewForm";
import AddIcon from "@material-ui/icons/Add";
import {
  Avatar,
  Button,
  List,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Menu,
  MenuItem,
  TableBody,
  TableContainer,
  TableHead,
  withWidth,
} from "@material-ui/core";
import {
  IZYTable,
  IZYTableRow,
  IZYTableCell,
} from "../../components/CustomStyles/CustomTable";
import Img from "../../components/Img";
import { formatCurrency } from "../../components/Utils/Currency";
import { Skeleton } from "@material-ui/lab";
import MoreVertIcon from "@material-ui/icons/MoreVert";
import { confirm } from "../../components/ConfirmationDialog/ConfirmationDialog";
import { usePrevState } from "../../Helpers/tools";
import { IzySwitch } from "../../components/CustomStyles/CustomSwitch";
import { useState } from "react";
import { useEffect } from "react";

const ProductListCard = (props) => {
  const {
    action,
    data,
    alldata,
    onClickAvailability,
    onClickEdit,
    onClickDelete,
  } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleClickEdit = () => {
    handleClose();
    onClickEdit(data);
  };

  const handleClickDeleteRestore = () => {
    handleClose();
    onClickDelete(data, alldata);
  };
  return (
    <IZYTableRow>
      <IZYTableCell>
        <List style={{ padding: 0 }}>
          <ListItem style={{ padding: 0 }}>
            <ListItemAvatar>
              <Avatar variant="rounded">
                <Img
                  src={data.main_image || data.image_urls[0]}
                  width={60}
                  height={60}
                />
              </Avatar>
            </ListItemAvatar>
            <ListItemText
              primary={<span className="font-11 font-bold">{data.name}</span>}
            />
          </ListItem>
        </List>
      </IZYTableCell>
      <IZYTableCell>{data.tenant.property.name || "-"}</IZYTableCell>
      <IZYTableCell>{data.tenant.name || "0"}</IZYTableCell>
      <IZYTableCell>
        {data.discounted_price && (
          <React.Fragment>
            <span className="text-decoration-line-through d-block">
              {formatCurrency(
                data.tenant.property.currency,
                data.price.value.toString()
              )}
            </span>
            <span className="font-11">
              {formatCurrency(
                data.tenant.property.currency,
                data.discounted_price.toString()
              )}
            </span>
          </React.Fragment>
        )}
        {!data.discounted_price && (
          <span className="font-11">
            {formatCurrency(
              data.tenant.property.currency,
              data.price.value.toString()
            )}
          </span>
        )}
      </IZYTableCell>
      <IZYTableCell>
        {/* <IzySwitch
          size="small"
          checked={!data.out_of_stock}
          color="primary"
          name="out_of_stock"
          onChange={() => {
            onClickAvailability(data);
          }}
          disabled={!action.patch || !action.update}
        /> */}
        {data.stock || "0"}
      </IZYTableCell>
      <IZYTableCell>
        {/* {(action.update || action.delete) && (
          <React.Fragment>
            <Button
              aria-controls="simple-menu"
              aria-haspopup="true"
              onClick={handleClick}
            >
              <MoreVertIcon />
            </Button>
            <Menu
              id="simple-menu"
              anchorEl={anchorEl}
              keepMounted
              open={Boolean(anchorEl)}
              onClose={handleClose}
            >
              {action.update && (
                <MenuItem onClick={handleClickEdit}>Edit</MenuItem>
              )}
              {action.delete && action.patch && (
                <MenuItem onClick={handleClickDeleteRestore}>
                  {data.deleted_st ? "Restore" : "Delete"}
                </MenuItem>
              )}
            </Menu>
          </React.Fragment>
        )} */}
        {/* <button onClick={handleClickDeleteRestore}>REMOVE</button> */}
        <button
          onClick={handleClickDeleteRestore}
          type="button"
          class="btn btn-outline-danger d-flex flex-row justify-content-center align-items-center "
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="13"
            height="13"
            fill="currentColor"
            class="bi bi-trash"
            viewBox="0 0 15 15"
          >
            <path d="M5.5 5.5A.5.5 0 0 1 6 6v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm2.5 0a.5.5 0 0 1 .5.5v6a.5.5 0 0 1-1 0V6a.5.5 0 0 1 .5-.5zm3 .5a.5.5 0 0 0-1 0v6a.5.5 0 0 0 1 0V6z"></path>
            <path
              fill-rule="evenodd"
              d="M14.5 3a1 1 0 0 1-1 1H13v9a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V4h-.5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1H6a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1h3.5a1 1 0 0 1 1 1v1zM4.118 4 4 4.059V13a1 1 0 0 0 1 1h6a1 1 0 0 0 1-1V4.059L11.882 4H4.118zM2.5 3V2h11v1h-11z"
            ></path>
          </svg>
          <div style={{ marginLeft: ".5rem", fontSize: ".7rem" }}>Remove</div>
        </button>
      </IZYTableCell>
    </IZYTableRow>
  );
};

const ProductListCardLoading = () => {
  return (
    <IZYTableRow>
      <IZYTableCell>
        <List style={{ padding: 0 }}>
          <ListItem style={{ padding: 0 }}>
            <ListItemAvatar>
              <Avatar variant="rounded">
                <Skeleton
                  variant="rect"
                  animation="wave"
                  width={60}
                  height={60}
                />
              </Avatar>
            </ListItemAvatar>
            <ListItemText primary={<Skeleton animation="wave" height={22} />} />
          </ListItem>
        </List>
      </IZYTableCell>
      <IZYTableCell>
        <Skeleton animation="wave" height={22} />
      </IZYTableCell>
      <IZYTableCell>
        <Skeleton animation="wave" height={22} />
      </IZYTableCell>
      <IZYTableCell>
        <Skeleton animation="wave" height={22} />
      </IZYTableCell>
      <IZYTableCell>
        <Skeleton animation="wave" height={22} />
      </IZYTableCell>
      <IZYTableCell></IZYTableCell>
    </IZYTableRow>
  );
};

const NewProduct = ({ width, params }) => {
  const [arrStatus, setArrStatus] = React.useState([
    {
      title: "Shop",
      sub_title: 0,
      deleted: false,
      status: "available",
      total_data: 0,
      active: true,
    },
    {
      title: "Dine",
      sub_title: 0,
      deleted: true,
      status: "available",
      total_data: 0,
      active: true,
    },
  ]);

  const [productState, productActions] = ProductStore();
  const [perPage, setPerPage] = React.useState(10);
  const [totalPage, setTotalPage] = React.useState(0);
  const [page, setPage] = React.useState(1);
  const [statusActive, setStatusActive] = React.useState(0);
  const [search, setSearch] = React.useState("");
  const prevPage = usePrevState(page);
  const prevSearch = usePrevState(search);
  const [triggerChangeShopDine, settriggerChangeShopDine] = useState(0);
  const user = JSON.parse(localStorage.getItem("user"));

  const toggleStatus = (index) => {
    setStatusActive(index);
    setPage(1);
  };

  const handleSearch = (e) => {
    setSearch(e.target.value);
  };
  const handleGetProductList = () => {
    if (triggerChangeShopDine === 0) {
      var query = {
        page: page || 1,
        perPage: perPage,
        recom_type: 3,
        property_id: user.operational.id,
        // deleted: arrStatus[statusActive].deleted === true ? "true" : "false",
        keyword: search,
      };
      productActions.getListRecommendation(query);
    } else {
      var query = {
        page: page || 1,
        perPage: perPage,
        recom_type: 4,
        property_id: user.operational.id,
        // deleted: arrStatus[statusActive].deleted === true ? "true" : "false",
        keyword: search,
      };
      productActions.getListRecommendation(query);
    }
  };
  useEffect(() => {
    handleGetResume(true);
  }, [triggerChangeShopDine]);

  const handleGetResume = (pararel) => {
    var params = {
      keyword: search,
      type: triggerChangeShopDine ? 3 : 4,
    };

    ProductService.getResumeCurrated(params)
      .then((response) => {
        let data = response.data;

        const remapStatus = arrStatus.map((value, index) => {
          return {
            ...value,
            sub_title: data[value.status] || 0,
            total_data: data[value.status] || 0,
            active: data[value.status] > 0 ? true : false,
          };
        });

        setArrStatus(remapStatus);

        if (pararel) {
          handleGetProductList();
        }
      })
      .catch((error) => {
        handleError(error);
      });
  };

  const handleChangePage = (page) => {
    setPage(page);
  };

  const handleChangePerPage = (perPage) => {
    setPerPage(perPage);
  };

  const handleActions = (value) => {
    if (value) {
      productForm("Update Product", value).then(
        (onProcess) => {},
        (onCancel) => {
          handleGetProductList();
        }
      );
    } else {
      productForm("Add Product", null).then(
        (onProcess) => {},
        (onCancel) => {
          handleGetResume(true);
        }
      );
    }
  };

  const setAvailability = (data) => {
    confirm(
      !data.out_of_stock ? "Set Item Not Available" : "Set Available",
      !data.out_of_stock
        ? "Set this Item Not Available ?"
        : "Set this Item Available ?"
    ).then(async (onProcess) => {
      const params = [
        {
          op: "replace",
          path: "/out_of_stock",
          value: !data.out_of_stock,
        },
      ];
      let notif = `Successfully ${
        !data.out_of_stock ? "Set Item Not Available" : "Set Available"
      }`;
      await productActions.patch(data.id, params, notif);
      handleGetProductList();
    });
  };

  const setStatusRemove = (data, value) => {
    confirm(
      `${!data.deleted_st ? "Remove Item" : "Restore Item"}`,
      `Are you sure to ${!data.deleted_st ? "remove" : "restore"} this item ?`
    ).then(async (onProcess) => {
      if (!data.deleted_st) {
        await productActions.deleteRecommendation(value.id);
      } else {
        // const params = [
        //   {
        //     op: "replace",
        //     path: "/deleted ",
        //     value: false,
        //   },
        // ];
        // let notif = `Successfully Restore Product`;
        // await productActions.patch(data.id, params, notif);
      }

      handleGetResume(true);
    });
  };
  React.useEffect(() => {
    const getTotalPage = GetTotalPage(
      arrStatus[statusActive]["total_data"],
      perPage
    );
    setTotalPage(getTotalPage);
  }, [arrStatus, statusActive, perPage]);

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      handleGetResume();
    }, 500);

    return () => clearTimeout(timeout);
  }, [search]);

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      handleGetProductList();
    }, 500);

    return () => clearTimeout(timeout);
  }, [page]);

  React.useEffect(() => {
    // Add delay in search
    const timeout = setTimeout(() => {
      const newPage = prevPage > 1 ? 1 : "";
      if (prevPage) {
        setPage(newPage);

        if (prevPage === newPage) {
          handleGetProductList();
        }
      } else if (prevPage === "" && page === "") {
        setPage(1);
      }
    }, 500);

    return () => clearTimeout(timeout);
  }, [search, perPage, statusActive]);

  // useEffect(() => {
  //   handleGetProductList();
  // }, []);
  return (
    <BaseLayout background="gray">
      <div className="row mx-0 w-100">
        <div className="col-12 px-0">
          <h3 className="font-16 font-bold mb-0">Product Recommendation</h3>
        </div>
        <div className="col-12 px-0">
          <div className="card rounded-8px border-0 mt-4">
            <div className="card-body border-0 px-4 pt-4 pb-0">
              <div className="w-100 d-flex justify-content-between align-items-center">
                <BootstrapInputSearch
                  placeholder="Search Product"
                  onChange={(e) => handleSearch(e)}
                />
                {width !== "sm" && width !== "xs" && params.create && (
                  <button
                    type="button"
                    className="btn btn-blue"
                    onClick={() => handleActions(null)}
                  >
                    CREATE
                  </button>
                )}
              </div>
              <p className="font-12 font-bold my-3">Status</p>
              <IzyTabsPanel
                tabs={arrStatus}
                tabActive={statusActive}
                onClick={(index) => {
                  // if (triggerChangeShopDine == 0) {
                  settriggerChangeShopDine(index);
                  toggleStatus(index);
                  // } else if (triggerChangeShopDine == 1) {
                  //   settriggerChangeShopDine(0);
                  //   toggleStatus(0);
                  // }
                }}
                showSubTittle="1"
              />
            </div>
            <div className="card-body border-0 px-4 pt-0 pb-4">
              <TableContainer>
                <IZYTable>
                  <TableHead>
                    <IZYTableRow>
                      <IZYTableCell align="left" width="30%">
                        Product
                      </IZYTableCell>
                      <IZYTableCell align="left" width="20%">
                        Property
                      </IZYTableCell>
                      <IZYTableCell align="left" width="15%">
                        Tenant
                      </IZYTableCell>
                      <IZYTableCell align="left" width="15%">
                        Price
                      </IZYTableCell>
                      <IZYTableCell align="left" width="15%">
                        Stock
                      </IZYTableCell>
                      <IZYTableCell align="left" width="5%"></IZYTableCell>
                    </IZYTableRow>
                  </TableHead>
                  <TableBody>
                    {!productState.isLoading &&
                      productState.alldata.length > 0 &&
                      productState.alldata.map((value, key) => {
                        return (
                          <ProductListCard
                            key={key}
                            data={value.product}
                            onClickAvailability={(data) =>
                              setAvailability(data)
                            }
                            onClickEdit={(data) => {
                              handleActions(data);
                            }}
                            onClickDelete={(data) => {
                              setStatusRemove(data, value);
                            }}
                            action={params}
                          />
                        );
                      })}

                    {productState.isLoading &&
                      Array.from(new Array(perPage)).map((value, key) => {
                        return <ProductListCardLoading key={key} />;
                      })}
                  </TableBody>
                </IZYTable>
              </TableContainer>
            </div>
          </div>
          <IzyPagination
            page={page || 1}
            perPage={perPage}
            total={arrStatus[statusActive]["total_data"] || 0}
            totalPage={totalPage}
            onChangePage={(page) => handleChangePage(page)}
            onChangePerPage={(perPage) => handleChangePerPage(perPage)}
          />
        </div>
      </div>
      {(width === "sm" || width === "xs") && params.create && (
        <StyledFAB color="primary" onClick={() => handleActions(null)}>
          <AddIcon />
        </StyledFAB>
      )}
    </BaseLayout>
  );
};

export default withWidth()(NewProduct);
